import { BoxFill } from "react-bootstrap-icons";
import { FaAddressCard } from "react-icons/fa";
import PackageEnum from "../../../enums/PackageEnum";
import dateTimeToJalali from "../../../function/jalali/dateTimetoJalali";

export default function PayLinkCheckoutCard({ orders }) {
  return (
    <div>
      {orders.map(item => (
        <div key={item.id} className="card-shadow rounded-1 mt-3 p-4">
          <div className="border-bottom d-flex flex-wrap">
            <strong className="text-orange fs-5">شماره سفارش: </strong>
            <strong className="text-orange fs-5">{item.numberParcel}</strong>

            <p className="me-auto">
              <span>تاریخ ثبت: </span>
              <span>{dateTimeToJalali(item.created_at).date}</span>
            </p>
          </div>

          <div className="d-flex flex-wrap align-items-center border rounded-1 mt-4 p-2">
            <div style={{ width: 120, height: 55 }}>
              <img
                src={item.company.image}
                className="w-100 h-100 object-fit-contain"
              />
            </div>
            <span>سرویس دهنده: </span>
            <strong className="me-2">{item.company.name}</strong>
            <span className="me-3">نوع:</span>
            <strong className="me-2">{item.company_type_post.name}</strong>
          </div>

          <section className="d-flex flex-wrap gap-3 mt-4">
            <div>
              <span>نمایندگی ثبت مرسوله (مبدا): </span>
              <strong>
                {item.agent.user.name} {item.agent.user.family}
              </strong>
            </div>

            <div>
              <span>موبایل: </span>
              <strong>{item.agent.mobile}</strong>
            </div>

            {item.agent.organizationMobile && (
              <div>
                <span>موبایل سازمانی: </span>
                <strong>{item.agent.organizationMobile}</strong>
              </div>
            )}
          </section>

          <div className="border rounded-1 mt-4 p-2 d-flex flex-wrap gap-3 align-items-center">
            <div>
              <FaAddressCard size="40" className="text-purple" />
            </div>

            <div>
              <span>فرستنده: </span>
              {item.source.type === 0 && (
                <strong>
                  {item.source.name} {item.source.family}
                </strong>
              )}
              {item.source.type === 1 && <strong>{item.source.compony}</strong>}
            </div>

            <div>
              <span>موبایل: </span>
              <span>{item.source.phone}</span>
            </div>

            <div>
              <span>آدرس: </span>
              <strong>
                <span>{item.source.province.faName}</span>
                <span> {item.source.city.faName}</span>
                <span> {item.source.address}</span>
              </strong>
            </div>
          </div>

          <div className="border rounded-1 mt-4 p-2 d-flex flex-wrap gap-3 align-items-center">
            <div>
              <FaAddressCard size="40" className="text-purple" />
            </div>

            <div>
              <span>گیرنده: </span>
              {item.destination.type === 0 && (
                <strong>
                  {item.destination.name} {item.destination.family}
                </strong>
              )}
              {item.destination.type === 1 && (
                <strong>{item.destination.compony}</strong>
              )}
            </div>

            <div>
              <span>موبایل: </span>
              <span>{item.destination.phone}</span>
            </div>

            <div>
              <span>آدرس: </span>
              <strong>
                <span>{item.destination.province.faName}</span>
                <span> {item.destination.city.faName}</span>
                <span> {item.destination.address}</span>
              </strong>
            </div>
          </div>

          <h5 className="mb-0 mt-4">اطلاعات مرسوله</h5>
          {item.internal_order.map(parcel => (
            <div
              key={parcel.id}
              className="d-flex flex-wrap gap-3 align-items-center mt-1 border rounded-1 p-2"
            >
              <div>
                <BoxFill className="text-orange" size="40" />
              </div>

              <div>
                <span>بسته بندی: </span>
                <strong>{PackageEnum[parcel.packageTypeId]}</strong>
              </div>

              <div>
                <span>وزن: </span>
                <strong>{parcel.weight}</strong>
                <span> (کیلوگرم)</span>
              </div>

              <div>
                <span>ابعاد:&nbsp;</span>
                <span>{parcel.height}</span>&nbsp;×
                <span> {parcel.length}</span>&nbsp;×
                <span> {parcel.width}</span>
              </div>

              <div>
                <span>محتویات: </span>
                <span>{parcel.shipment}</span>
              </div>

              <div>
                <span>ارزش کالا: </span>
                <strong>{parcel.value.toLocaleString()} </strong>
                <span>ریال</span>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
